export const LEAD_TAG_COLORS = [
  "purple",
  "blue",
  "teal",
  "green",
  "amber",
  "red",
  "pink",
  "gray",
] as const;
export type LeadTagColor = (typeof LEAD_TAG_COLORS)[number];

export const LEAD_TAG_STATUSES = ["active", "archived"] as const;
export type LeadTagStatus = (typeof LEAD_TAG_STATUSES)[number];

export type LeadTag = {
  merchantId: string;
  id: string;
  name: string;
  color: LeadTagColor;
  status: LeadTagStatus;
  createdAt: string;
  updatedAt: string;
};

export type LeadTagKey = { merchantId: string; id: string };

export type ListLeadTagsInput = { merchantId: string };

export type CreateLeadTagInput = Pick<LeadTag, "merchantId" | "name" | "color">;

export type UpdateLeadTagInput = LeadTagKey & Partial<Pick<LeadTag, "name" | "color" | "status">>;
